import { LitElement, html, css } from '@hh/global.js'

class HHProductStickyBar extends LitElement {
  static properties = {
    'form-id': { type: String },
  }

  static styles = css`
    :host {
      display: block;
    }
  `

  constructor() {
    super()
    window.addEventListener('scroll', this.onScroll.bind(this))
    window.addEventListener('variant:change', this.onVariantChange.bind(this))
  }

  onScroll() {
    const header = document.querySelector('#shopify-section-header');
    const gallery = document.querySelector('[data-product-media]');
    const sumHeight = header.offsetHeight + gallery.offsetHeight + this.offsetHeight;
    const isTop = window.scrollY === 0;

    this.classList.toggle(
      'is-fixed',
      window.scrollY < !isTop && sumHeight - window.innerHeight
    );
  }

  onAdd(event) {
    if (event.target.getAttribute('data-notify') === 'true') {
      const backInStock = document.querySelector('hh-back-in-stock')
      backInStock.querySelector('button').click()
      backInStock.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
      return
    }
    document
      .querySelector(`#${this['form-id']}`)
      .querySelector('[name="add"]')
      ?.click()
  }

  onVariantChange(event) {
    const button = this.querySelector('button')
    button.setAttribute('data-notify', !event.detail.variant.available)
    button.textContent = event.detail.variant.available
      ? window.variantStrings.addToCart
      : window.variantStrings.getNotified
  }

  render() {
    return html`<slot @click="${this.onAdd.bind(this)}"></slot>`
  }
}

customElements.define('hh-product-sticky-bar', HHProductStickyBar)
